<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="/impressum">
              Impressum
            </a>
          </li>
          <li>
            <a href="/datenschutz">
              Datenschutz
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }} Ferienhaus deBontje, Vorlage von
        <a href="https://www.creative-tim.com/" target="_blank">Creative Tim</a
        >.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
